import { Box, CircularProgress } from "@mui/material";

export default function LoadingScreen(props: { size?: number }) {
  return (
    <Box
      component="span"
      sx={{ display: "inline-block", mx: "2px", transform: "scale(0.8)" }}
    >
      <CircularProgress size={props.size} />
    </Box>
  );
}
